<style>
  .zipcodesOutput {
    margin: auto auto;
    margin-top: 1vh;
    background-color: white;
    min-height: 50px;
    border-radius: 8px;
    padding: 10px;
    border: 1px dashed black;
  }
  .zipcodeNode {
    position: relative;
    border-width: 3px;
    border-style: solid;
    border-color: #24526d;
    border-radius: 10px;

    color: white;

    background-color: #203449;

    display: inline-block;
    padding: 5px;
    margin: 5px;
  }
  .zipcodeNode:hover {
    cursor: pointer;
  }
  .zipcodeNode:hover::after {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.5);
    /* inverse of black */
    content: url("static/icons/hand-drawn/delete.svg");
    padding: 0.8rem;
    padding-top: 0.4rem;
    filter: invert(1);
    border-radius: 0.7rem;
  }
</style>
<div class="Tooltip">
  {#if isTvOwner}
Location
  {:else}
Target Location 
  {/if}
  <span class="Tooltiptext">
  {#if isTvOwner}
    This is the zipcode in where your brick and mortar store is located
  {:else}
    This is your desired area(s) you would like your ad to be seen in
  {/if}
  </span>
</div>
<div class="form-group">
  <label for="zipcodesInput"
    ><span class="required--input">(*)</span>&thinsp; Write a zipcode and just press space. Click on the word to
    delete</label
  >
  <input
    class="form-control"
    id="zipcodesInput"
    pattern="[0-9]*"
    placeholder="Enter Seven Digit Zipcode"
    bind:value="{valueInput}"
    on:input="{putIntoZipcode}"
  />
  <div class="zipcodesOutput">
    {#each zipcodeValues as zipcodeValue, i}
    <div class="zipcodeNode" in:fly="{{x:-20}}" out:fade on:click="{() => deleteItem(i)}">
      {zipcodeValue}
    </div>
    {/each}
  </div>
</div>

<script>
  import { fly, fade } from "svelte-transitions";
  export let isTvOwner
  // class = "",
  let valueInput = null
  export let zipcodeValues = []

  function putIntoZipcode() {
    const filteredString = valueInput.replace(/[^01234567890%-]/g, "");
    if (filteredString.length === 5) {
      zipcodeValues = [...zipcodeValues, filteredString]
      valueInput = null
    }
  }
  function deleteItem(toDeleteI) {
    zipcodeValues = zipcodeValues.filter((deleteItem, i) => i !== toDeleteI)
  }


</script>